import { Box, IconButton } from "@mui/material";
import MoreIcon from "../../../../../assets/images/more";
import { Colors } from "../../../../../configs";
import { FC } from "react";
import GarmentTypeSection from "../../../../common/pos/garment-type-section/garment-type-section";
import GarmentModificationSection from "../../../../common/pos/garment-modification-section/garment-modification-section";
import ReplayIcon from "@mui/icons-material/Replay";
import { useAppDispatch, useAppSelector } from "../../../../../hooks";
import AlterationSecondSubSelection from "../../../../common/pos/alteration-second-sub-section/alteration-second-sub-section";
import { Link, useParams } from "react-router-dom";
import { CustomButton, PosButton } from "../../../../atoms";
import BottomActionButtons from "../BottomActionButtons";
import { addCartItem } from "../../../../../redux/actions/cartAction";
import { CheckroomOutlined, Redo } from "@mui/icons-material";
import ServiceActionButtons from "../../../../common/pos/service-action-buttons/service-action-buttons";
import RedoModal from "../../../redo-modal/RedoModal";

const Alteration: FC = () => {
  const params = useParams();
  const { selectedCartItem } = useAppSelector((state) => state.cart);

  const isDisabled = () => {
    return selectedCartItem?.alterationItems.some(
      (item) => !item.alterationPrice || !item.alterationSubCategory
    );
  };
  const dispatch = useAppDispatch();
  const baseMissing =
    !selectedCartItem?.garmentType ||
    !selectedCartItem?.materialType ||
    !selectedCartItem?.garmentStyle;

  const alterationInvalid = Boolean(
    selectedCartItem?.alterationItems?.some(
      (item) => !item.alterationSubCategory || !item.alterationPrice
    )
  );

  const disableAdd = baseMissing || alterationInvalid;

  const handleOnAddItem = () => {
    dispatch(addCartItem());
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          gap: "0.71rem",
          justifyContent: "space-between",
        }}
      >
        <Box sx={{ flex: 8 }}>
          <GarmentTypeSection />
        </Box>
        <Box sx={{ flex: 4 }}>
          <GarmentModificationSection />
        </Box>
      </Box>
      <AlterationSecondSubSelection />
      {/* Alteration Second Sub Selection */}
      <Box
        sx={{
          marginTop: "auto",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "0rem 0.928571429rem",
          gap: "1.5rem",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: "2.5rem",
          }}
        >
          <Link to={`/pos/customer/${params.id}/history/`}>
            <PosButton
              variant="outlined"
              sx={{
                width: "28.21428571428571rem",
                borderRadius: "1.43rem",
                boxShadow: "0 6px 16px rgba(1, 135, 82, 0.18)",
                transition: "transform 0.15s ease",
                "&:active": {
                  transform: "scale(0.99)",
                },
              }}
            >
              Pickups
            </PosButton>
          </Link>
        </Box>
        <ServiceActionButtons />
        <BottomActionButtons
          onAddClick={handleOnAddItem}
          disable={disableAdd}
        />
      </Box>
      <RedoModal />
    </>
  );
};

export default Alteration;
